<template>
	<v-dialog
			persistent
			v-model="show_"
			width="750px">
		<template v-slot:activator="{ on }">
			<v-btn class="customVBtn" v-on="on">
				<v-row no-gutters align="end">
					<v-col class="center">
						<v-icon>pets</v-icon>
					</v-col>
					<v-col class="ml-2 center">
						<span class="button_">EXECUTE</span>
					</v-col>
				</v-row>
			</v-btn>
		</template>
		<v-card class="customVCard">
			<template v-if="mode_.execute">
				<v-row class="px-2 pt-2">
					<v-col>
						<v-expansion-panels flat>
							<template v-for="(buttonVals, buttonKey) in $_dbgBtn_stateDebugButtons()">
								<v-expansion-panel :key="buttonKey">
									<v-expansion-panel-header>
										<span class="subtitle-1" v-text="buttonVals.title" />
									</v-expansion-panel-header>
									<v-expansion-panel-content>
										<template v-if="!isFalse(buttonVals.description)">
											<v-row>
												<v-col>
													<span	class="caption markdown"
															v-html="marked(buttonVals.description)" />
												</v-col>
											</v-row>
										</template>
										<template v-if="!isEmpty(buttonVals.data)">
											<v-row>
												<v-col>
													<v-alert
															class="customVAlert"
															color="error"
															outlined>
														<pre	class="prettyprint caption pretty_"
																v-html="buttonVals.data" />
													</v-alert>
												</v-col>
											</v-row>
											<v-row>
												<v-col>
													<v-textarea color="error" hide-details outlined v-model="data_" />
												</v-col>
											</v-row>
										</template>
										<template v-if="!isFalse(errorMessage_)">
											<v-row justify="center">
												<v-col cols="auto">
													<span class="error_" v-text="errorMessage_" />
												</v-col>
											</v-row>
										</template>
										<v-row justify="center">
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														block
														color="error"
														large
														@click="$_dbgBtn_execute(buttonVals, buttonKey)">
													Execute
												</v-btn>
											</v-col>
										</v-row>
								</v-expansion-panel-content>
								</v-expansion-panel>
							</template>
						</v-expansion-panels>
					</v-col>
				</v-row>
			</template>
			<template v-if="mode_.result">
				<v-row class="px-2 pt-2">
					<v-col>
						<template v-for="(result, index) in $_dbgBtn_stateDebugResult()">
							<v-alert
									:key="index"
									color="error"
									outlined>
								<pre	class="prettyprint caption pretty_"
										v-html="result" />
							</v-alert>
						</template>
					</v-col>
				</v-row>
			</template>
			<v-row class="px-2 pb-3" justify="center" dense>
				<v-col cols="auto">
					<v-btn	class="customVBtn"
							block
							color="secondary"
							large
							@click="$_dbgBtn_close()">
						Close
					</v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'DebuggerButton',
		data() {
			return {
				show_: false,

				errorMessage_: null,

				mode_: {
					execute: true,
					result: false
				},

				data_: null
			}
		},
		computed: {
			// state
			$_dbgBtn_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_dbgBtn_stateDebugButtons() {
				const self_ = this;
				return () => {
					let buttons_ = self_.getDebugState('buttons')
					// custom for bri life start
					buttons_.customBriLifeSendNotificationEmail = {
						title: 'Send Notification Email (Not in use)',
						description: '',
						data: {}
					}
					buttons_.customBriLifeSetFirestore = {
						title: 'Set Firestore',
						description: '',
						data: {}
					}
					// custom for bri life start
					return buttons_
				}
			},
			$_dbgBtn_stateDebugResult() {
				const self_ = this;
				return () => {
					return self_.getDebugState('result')
				}
			}
		},
		methods: {
			$_dbgBtn_execute(buttonVals, buttonKey) {
				const self_ = this;

				if(!self_.isEmpty(buttonVals.data) && self_.isEmpty(self_.data_)) {
					self_.errorMessage_ = 'data is empty!';
					return
				}

				self_.setDebugState('data', JSON.parse(self_.data_))
				self_.setDebugState('result', [])

				Promise.resolve().then(() => {
					if(buttonKey == 'debugMakeIpcEnv') { return self_.debugMakeIpcEnv() }
					if(buttonKey == 'debugAddAdminUser') { return self_.debugAddAdminUser() }
					if(buttonKey == 'debugResetUser') { return self_.debugResetUser() }
					if(buttonKey == 'debugMoveUsersToLaravel') { return self_.debugMoveUsersToLaravel() }
					if(buttonKey == 'debugMovePointToLaravel') { return self_.debugMovePointToLaravel() }
					if(buttonKey == 'debugRunGPU') { return self_.debugRunGPU() }
					if(buttonKey == 'debugSetMenuItemsFromMenus') { return self_.debugSetMenuItemsFromMenus() }
					// custom for bri life start
					if(buttonKey == 'customBriLifeSendNotificationEmail') { return self_.customBriLifeSendNotificationEmail() }
					if(buttonKey == 'customBriLifeSetFirestore') { return self_.customBriLifeSetFirestore() }
					// custom for bri life end
				}).then(() => {
					self_.mode_ = { result: true }
				}).catch(error => {
					self_.errorMessage_ = error;
				})
			},
			$_dbgBtn_close() {
				const self_ = this;

				self_.show_ = false;

				self_.mode_ = { execute: true }
				self_.data_ = null;
				self_.errorMessage_ = null;
			}
		}
	}
</script>

<style scoped>
	.button_ {
		font-size: xx-small !important;
	}
	.error_ {
		color: #ff5252;
	}
	.pretty_ {
		border: none;
		color: #ff5252;
	}
</style>
